namespace GeniuzPOS.Administration {
    export interface PoApprovalGroupRow {
        Id?: number;
        ApprGroupCode?: string;
        ApprGroupName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PoApprovalGroupRow {
        export const idProperty = 'ApprGroupCode';
        export const nameProperty = 'ApprGroupName';
        export const localTextPrefix = 'Administration.PoApprovalGroup';
        export const lookupKey = 'Administration.PoApprovalGroup';

        export function getLookup(): Q.Lookup<PoApprovalGroupRow> {
            return Q.getLookup<PoApprovalGroupRow>('Administration.PoApprovalGroup');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            ApprGroupCode = "ApprGroupCode",
            ApprGroupName = "ApprGroupName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
